import { EmptyState } from '@mint-lib/tw-components/patterns';

function NotFound() {
  return (
    <EmptyState
      size="medium"
      title="error 404"
      description="Page not found"
      illustration="IllustrationError404"
    />
  );
}

export default NotFound;
